// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const SocialWebsiteIcon = props => <Icon {...props} dangerouslySetIcon={'<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.619 2.214a1 1 0 00-1.238 0l-8 6.3A1 1 0 003 9.3v9.9c0 .739.29 1.45.81 1.976S5.036 22 5.777 22h12.444c.741 0 1.449-.298 1.969-.825.52-.526.809-1.236.809-1.975V9.3a1 1 0 00-.381-.786l-8-6.3zM5 19.2V9.785l7-5.512 7 5.512V19.2a.811.811 0 01-.232.57.766.766 0 01-.546.23h-2.555v-8a1 1 0 00-1-1H9.333a1 1 0 00-1 1v8H5.778a.767.767 0 01-.546-.23A.811.811 0 015 19.2zm5.333.8h3.334v-7h-3.334v7z" fill="currentColor"/></svg>'} />;

SocialWebsiteIcon.displayName = 'SocialWebsiteIcon';

export default SocialWebsiteIcon;
